import { render, staticRenderFns } from "./LensSlider.vue?vue&type=template&id=700db67a&scoped=true&"
import script from "./LensSlider.vue?vue&type=script&lang=js&"
export * from "./LensSlider.vue?vue&type=script&lang=js&"
import style0 from "./LensSlider.vue?vue&type=style&index=0&id=700db67a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700db67a",
  null
  
)

export default component.exports